import { TemplateSelectionModal } from '@frontend/integrated-messaging';
import { MessagingSelectInvoiceModal } from '@frontend/payments-collection-flow';
import { FeatureUpgradeModalWrapper } from '@frontend/self-upgrade';
import { UseInboxTemplateFlowsResults } from '../hooks';
import { FormsTemplateModal } from './forms-template-modal';
import { ScheduleTemplateModal } from './schedule-template-modal';

type InboxTemplatesModalsProps = UseInboxTemplateFlowsResults['modalsProps'];

export const InboxTemplatesModals = ({
  manualTemplateModalProps,
  scheduleTemplateModalProps,
  reviewInvitationModalProps,
  selectInvoiceModalProps,
  formsTemplateModalProps,
  formsPromotionModalProps,
}: InboxTemplatesModalsProps) => {
  return (
    <>
      <TemplateSelectionModal {...manualTemplateModalProps} />
      <ScheduleTemplateModal {...scheduleTemplateModalProps} />
      <TemplateSelectionModal {...reviewInvitationModalProps} />
      <MessagingSelectInvoiceModal {...selectInvoiceModalProps} />
      <FormsTemplateModal {...formsTemplateModalProps} />
      <FeatureUpgradeModalWrapper {...formsPromotionModalProps} />
    </>
  );
};
